import Vue from 'vue';
import { isObject } from 'Helpers/utils/common';
import HttpClient from 'Api/HttpClient';
import analytics from 'Analytics';
import {
  FormBeforeSendValidationError,
  FormBeforeSendNoChangesError,
  FormBeforeSendBotDetectedError,
} from 'Classes';

export default class BaseModel {
  constructor(data = {}) {
    // Method of save request
    this.$method = 'POST';
    // http client
    this.$httpClient = null;
    // Data which send in request
    this.$requestData = null;
    this.$loadingSend = false;
    this.$sendSuccess = false;
    // Do not show message once after send. Reset in any send case
    this.$skipShowMessageOnce = false;
    // Text for toaster on success send
    this.$messageSuccess = 'Saved';
    this.$gtmEvent = '';
    // error messages
    this.$messageErrors = {
      no_changed_data: {
        code: 'no_changed_data',
        text: 'No changes',
      },
      validation_error: {
        code: 'validation_error',
        text: 'One or more fields are invalid',
      },
      bot_detected: {
        code: 'bot_detected',
        text: 'We are unable to allow you to signup/sign in at the moment. Please reach out to us with any questions: <a class="link1" href="mailto:info@acretrader.com">info@acretrader.com</a>',
      },
    };

    // Number of send attempts;
    this.$set('$sendAttempts', 0);
    this.$setAll(data);
    this.$httpClient = new HttpClient(this.$url);
  }

  get $url() {
    return '';
  }

  get $path() {
    return '';
  }

  get $getDataPath() {
    return '';
  }

  get $beforeSendNoChangesError() {
    return new FormBeforeSendNoChangesError();
  }

  get $beforeSendValidationError() {
    return new FormBeforeSendValidationError();
  }

  get $beforeSendBotDetectedError() {
    return new FormBeforeSendBotDetectedError();
  }

  _beforeSend() {
    this.$sendAttempts += 1;
    this.$loadingSend = true;
    return true;
  }

  _gtmEventHandler(params = {}) {
    if (this.$gtmEvent) analytics.triggerFormSubmit(this.$gtmEvent, params);
  }

  _onSendSuccess(response, params = {}) {
    this.$sendSuccess = true;
    this._gtmEventHandler(params);
    return Promise.resolve(response);
  }

  _onSendError(error) {
    return error;
  }

  _onSendAlways() {
    this.$skipShowMessageOnce = false;
    this.$loadingSend = false;
  }

  $set(name, value, model = this) {
    Vue.set(model, name, value);
  }

  $setAll(data, model = this) {
    if (!data || typeof data !== 'object') return;
    Object.entries(data)
      .forEach(([key, value]) => {
        // If value is object and model exist as object too
        if (isObject(value) && isObject(model[key])) {
          // Call recursive to not lost observe set by field params in object
          this.$setAll(value, model[key]);
        } else {
          this.$set(key, value, model);
        }
      });
  }

  async send(ignoreValidation) {
    await this._beforeSend(ignoreValidation);
    try {
      let response = await this.$httpClient.request(
        this.$method,
        this.$path,
        this.$requestData,
      );
      response = await this._onSendSuccess(response);
      this._onSendAlways(response);
      return response;
    } catch (error) {
      this._onSendError(error);
      this._onSendAlways();
      throw error;
    }
  }
}
